module.exports = __webpack_public_path__ + "04a53a5b01fb03a84bb1b038fa9d7f7d.svg";